import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';

const TestimonialCarousel = () => {
  const [currentSlide, setCurrentSlide] = useState(0);

  const testimonials = [
  {
    name: "Sarah Mitchell",
    role: "First-Time Crypto Investor",
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_1fb6cf439-1763299224286.png",
    imageAlt: "Professional woman with brown hair wearing white blazer smiling confidently in modern office setting with natural lighting",
    rating: 5,
    text: "Kryptostash made my first cryptocurrency investment incredibly easy and secure. The educational resources helped me understand the market before investing my money. I feel confident and protected with their bank-level security."
  },
  {
    name: "Michael Chen",
    role: "Experienced Trader",
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_15be4265d-1763301291596.png",
    imageAlt: "Asian man with short black hair wearing navy blue suit and white shirt with professional smile in corporate office environment",
    rating: 5,
    text: "After trying multiple platforms, Kryptostash stands out with its regulatory compliance and transparent fee structure. The advanced trading tools combined with excellent customer support make it my go-to platform for serious investing."
  },
  {
    name: "Emily Rodriguez",
    role: "Retirement Planner",
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_13f5907c7-1763298966546.png",
    imageAlt: "Hispanic woman with long dark hair wearing professional gray business suit smiling warmly in bright modern office space",
    rating: 5,
    text: "As someone planning for retirement, security is my top priority. Kryptostash's FDIC-insured deposits and third-party security audits give me peace of mind. Their educational approach helped me diversify my portfolio confidently."
  },
  {
    name: "David Thompson",
    role: "Small Business Owner",
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_1af00294e-1763294385253.png",
    imageAlt: "Caucasian man with short brown hair and beard wearing casual blue shirt smiling in contemporary workspace with laptop",
    rating: 5,
    text: "The seamless ACH integration and instant deposits make managing my business cryptocurrency investments effortless. Kryptostash\'s 24/7 support team has been incredibly responsive whenever I needed assistance with transactions."
  }];


  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % testimonials?.length);
  };

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev - 1 + testimonials?.length) % testimonials?.length);
  };

  return (
    <section className="py-12 md:py-16 lg:py-24 bg-[var(--color-card)]">
      <div className="max-w-7xl mx-auto px-4 md:px-6 lg:px-8">
        <div className="text-center mb-12 md:mb-16">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-[var(--color-foreground)] mb-4">
            Trusted by Thousands of Investors
          </h2>
          <p className="text-base md:text-lg text-[var(--color-muted-foreground)] max-w-3xl mx-auto">
            See what our community has to say about their experience with Kryptostash
          </p>
        </div>

        <div className="relative max-w-4xl mx-auto">
          <div className="bg-[var(--color-background)] rounded-2xl p-6 md:p-8 lg:p-12 border border-[var(--color-border)]">
            <div className="flex flex-col md:flex-row items-center gap-6 md:gap-8">
              <div className="flex-shrink-0">
                <div className="w-20 h-20 md:w-24 md:h-24 lg:w-32 lg:h-32 rounded-full overflow-hidden border-4 border-[var(--color-primary)]">
                  <Image
                    src={testimonials?.[currentSlide]?.image}
                    alt={testimonials?.[currentSlide]?.imageAlt}
                    className="w-full h-full object-cover" />

                </div>
              </div>

              <div className="flex-1 text-center md:text-left">
                <div className="flex items-center justify-center md:justify-start gap-1 mb-3">
                  {[...Array(testimonials?.[currentSlide]?.rating)]?.map((_, i) =>
                  <Icon key={i} name="Star" size={20} color="var(--color-accent)" strokeWidth={0} className="fill-current" />
                  )}
                </div>

                <p className="text-base md:text-lg text-[var(--color-foreground)] mb-4 md:mb-6 leading-relaxed">
                  "{testimonials?.[currentSlide]?.text}"
                </p>

                <div>
                  <p className="text-base md:text-lg font-semibold text-[var(--color-foreground)]">
                    {testimonials?.[currentSlide]?.name}
                  </p>
                  <p className="text-sm md:text-base text-[var(--color-muted-foreground)]">
                    {testimonials?.[currentSlide]?.role}
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div className="flex items-center justify-center gap-4 mt-6 md:mt-8">
            <button
              onClick={prevSlide}
              className="w-10 h-10 md:w-12 md:h-12 rounded-full bg-[var(--color-primary)] text-white flex items-center justify-center hover:bg-opacity-90 transition-all"
              aria-label="Previous testimonial">

              <Icon name="ChevronLeft" size={24} color="#FFFFFF" />
            </button>

            <div className="flex gap-2">
              {testimonials?.map((_, index) =>
              <button
                key={index}
                onClick={() => setCurrentSlide(index)}
                className={`w-2 h-2 md:w-3 md:h-3 rounded-full transition-all ${
                index === currentSlide ?
                'bg-[var(--color-primary)] w-6 md:w-8' :
                'bg-[var(--color-border)]'}`
                }
                aria-label={`Go to testimonial ${index + 1}`} />

              )}
            </div>

            <button
              onClick={nextSlide}
              className="w-10 h-10 md:w-12 md:h-12 rounded-full bg-[var(--color-primary)] text-white flex items-center justify-center hover:bg-opacity-90 transition-all"
              aria-label="Next testimonial">

              <Icon name="ChevronRight" size={24} color="#FFFFFF" />
            </button>
          </div>
        </div>
      </div>
    </section>);

};

export default TestimonialCarousel;